<template>
  <button class @click="play()">
    <i :class="nowPlaying ? 'fa-pause' : 'fa-play'" id="player-play" class="fa fa-5x fa-fw" style="font-size: 22px !important"></i>
  </button>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: ['shiurim', 'magidShiur', 'type', 'hideText', 'width', 'height'],
  computed: {
    ...mapState({
      track: function (state) {
        return state.player.track;
      },
      playing: function (state) {
        return state.player.playing;
      },
      initialized: function (state) {
        return state.player.initialized;
      },
    }),
    nowPlaying: function () {
      return this.track.id == this.shiurim.id && this.playing;
    },
    name: function () {
      var name;
      if (this.type == 'shas') {
        name = this.shiurim.masechta.name + ' ' + this.shiurim.daf;
      } else if (this.type == 'mishna') {
        name = this.$t('KW:mishnaShiurTitle', {
          masechta: this.shiurim.book.name,
          chapter: this.shiurim.mishna_chapter,
          mishna: this.shiurim.mishna_number,
        });
      } else {
        name = this.shiurim.name;
      }
      if (this.magidShiur) {
        name += ' by ' + this.magidShiur.name;
      }
      return name;
    },
  },
  methods: {
    play: function () {
      if (!this.initialized) {
        $('#player-play').click();
      }

      if (this.track.id == this.shiurim.id && !this.track.isVideo) {
        this.$store.dispatch('player/setStatus', !this.playing);
        return;
      }

      this.$store.dispatch('player/setTrack', {
        id: this.shiurim.id,
        name: this.name,
        image: this.magidShiur && this.magidShiur.image ? this.magidShiur.image.url : null,
        track: this.shiurim.url_download,
        isVideo: false,
        trackName: this.name.split(' by ')[0].trim(),
        lecturerName: this.name.split(' by ')[1].trim(),
        durationPlayed: this.shiurim.history ? this.shiurim.history.duration_played : 0,
      });
      this.$store.dispatch('player/setStatus', true);
    },
  },
};
</script>
<style scoped>
svg {
  margin-left: 4px;
}
.fa-pause {
  color: #ffd181 !important;
  font-size: 1.2rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
